import React from 'react'
import { connect } from 'react-redux'
import { setModal } from '@hixme/modal'

import { UNLOCK_CART } from 'modal-constants'
import { selectors as userSessionSelectors } from 'store/modules/user-session'

import InfoCard from '../InfoCard'

type UnlockCartCardProps = {
  showUnlockModal: (enrollmentEndDateFormatted: string) => void
  enrollmentEndDateFormatted: string
}

const LockIcon = () => (
  <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 11H6C4.89543 11 4 11.8954 4 13V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V13C20 11.8954 19.1046 11 18 11Z"
      stroke="#8f9da8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11"
      stroke="#8f9da8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const UnlockCartCard = ({ showUnlockModal, enrollmentEndDateFormatted }: UnlockCartCardProps) => (
  <InfoCard
    Image={LockIcon}
    title="Need to change your plan?"
    message={`You can unlock your cart and continue to shop until ${enrollmentEndDateFormatted}.`}
    onClick={() => showUnlockModal(enrollmentEndDateFormatted)}
    buttonLabel="Unlock My Cart"
    state="resume"
    buttonStyle={{ backgroundColor: '#eb5565', color: '#fff' }}
  />
)

const mapStateToProps = (state) => {
  const enrollmentEndDateFormatted = userSessionSelectors.getEnrollmentEndDateTimeFormattedSelector(state)
  return {
    enrollmentEndDateFormatted,
  }
}

const mapDispatchToProps = (dispatch) => ({
  showUnlockModal: (enrollmentEndDateFormatted: string) => {
    dispatch(setModal(UNLOCK_CART, { enrollmentEndDateFormatted }))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(UnlockCartCard)

